import { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

// Thunks
import { setCurrentPath } from '../store/core/core.thunks';

/**
 * Custom React Hook for tracking route changes.
 * @returns {void}
 */
export const useRouterHistory = (): void => {

  const { pathname } = useLocation();
  const dispatch = useDispatch<any>();

  /**
   * Saves the current location in store state.
   * @returns {void}
   */
  const saveCurrentLocation = (): void => {
    const replacedValue = pathname.replace('/', '');

    dispatch(setCurrentPath(replacedValue));
  }

  /**
   * Use the useLayoutEffect hook to run the saveCurrentLocation function whenever the pathname changes.
   */
  useLayoutEffect(() => {
    saveCurrentLocation();
  }, [pathname]);
};
